import { compose, withProps } from 'recompose'
import { connect } from 'react-redux'
import TireLineTile from 'components/BrandDetailsPage/BrandTireLines/BOTCommonBrandTireResultList/components/TireLineTile/TireLineTile'
import { getCurrentStorePhoneNumber } from 'selectors/getCurrentStore'

const mapStateToProps = state => ({
  storePhoneNumber: getCurrentStorePhoneNumber(state)
})

const withPriceFormatProps = withProps(({ startingListPrice }) => ({
  startingListPrice: String(startingListPrice).replace('$', '')
}))

const withPriceProps = withProps(({ storePhoneNumber, startingListPrice }) => ({
  isShowPrice: !!Number(startingListPrice) && Boolean(storePhoneNumber)
}))

export default compose(
  connect(mapStateToProps),
  withPriceFormatProps,
  withPriceProps
)(TireLineTile)
